(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2033],{

/***/ 32033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ Button_Button; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(77637);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_babel-plugin-macros@3.1.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.101.6/node_modules/next/link.js
var next_link = __webpack_require__(87597);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./hooks/useTheme.ts
var useTheme = __webpack_require__(14866);
// EXTERNAL MODULE: ./components/Typography/index.ts + 1 modules
var Typography = __webpack_require__(39181);
// EXTERNAL MODULE: ./components/Button/Button.module.scss
var Button_module = __webpack_require__(27148);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./components/Button/Button.tsx









var Button = /*#__PURE__*/ react.forwardRef(function(_param, ref) {
    var _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = _param.size, size = _size === void 0 ? "md" : _size, label = _param.label, children = _param.children, icon = _param.icon, _iconPosition = _param.iconPosition, iconPosition = _iconPosition === void 0 ? "left" : _iconPosition, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _loading = _param.loading, loading = _loading === void 0 ? false : _loading, _className = _param.className, className = _className === void 0 ? "" : _className, disabled = _param.disabled, href = _param.href, props = (0,_object_without_properties/* default */.Z)(_param, [
        "variant",
        "size",
        "label",
        "children",
        "icon",
        "iconPosition",
        "fullWidth",
        "loading",
        "className",
        "disabled",
        "href"
    ]);
    var theme = (0,useTheme/* useTheme */.Fg)().theme;
    var buttonClasses = [
        (Button_module_default()).button,
        (Button_module_default())[variant],
        (Button_module_default())[size],
        !fullWidth && (Button_module_default()).autoWidth,
        loading && (Button_module_default()).loading,
        disabled && (Button_module_default()).disabled,
        className, 
    ].filter(Boolean).join(" ");
    var renderIcon = function() {
        if (loading) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Button_module_default()).spinner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Button_module_default()).spinnerInner
                })
            });
        }
        return icon;
    };
    var buttonStyle = {
        // Colors
        "--button-bg": variant === "primary" ? theme.colors.palettes.brand[600] : variant === "secondary" ? theme.colors.palettes.grayLight[950] : "transparent",
        "--button-bg-hover": variant === "primary" ? theme.colors.palettes.brand[700] : variant === "secondary" ? theme.colors.palettes.grayLight[900] : theme.colors.palettes.grayLight[25],
        "--button-bg-active": variant === "primary" ? theme.colors.palettes.brand[700] : variant === "secondary" ? theme.colors.palettes.grayLight[800] : theme.colors.palettes.grayLight[50],
        "--button-text": variant === "primary" ? theme.colors.palettes.grayModern[50] : variant === "secondary" ? theme.colors.palettes.grayLight[25] : theme.colors.palettes.brand[600],
        "--button-border": variant === "primary" ? "transparent" : variant === "secondary" ? theme.colors.palettes.grayLight[800] : "transparent",
        // Button specific styles from theme
        "--button-border-radius": theme.button.borderRadius[size],
        "--button-padding-horizontal": theme.button.padding[size].horizontal,
        "--button-padding-vertical": theme.button.padding[size].vertical,
        "--button-font-size": theme.button.fontSize[size],
        "--button-font-weight": theme.button.fontWeight,
        "--button-min-height": theme.button.minHeight[size],
        "--button-transition": theme.button.transition,
        "--button-box-shadow": theme.button.boxShadow.default,
        "--button-box-shadow-hover": theme.button.boxShadow.hover,
        "--button-box-shadow-active": theme.button.boxShadow.active
    };
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (icon || loading) && (iconPosition === "left" || iconPosition === "both") && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    marginRight: label ? "0.25rem" : "0"
                },
                children: renderIcon()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Button_module_default()).content,
                children: label ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                    variant: "text-sm",
                    as: "span",
                    color: "inherit",
                    weight: "semibold",
                    children: label
                }) : children
            }),
            (icon || loading) && (iconPosition === "right" || iconPosition === "both") && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    marginLeft: label ? "0.25rem" : "0"
                },
                children: renderIcon()
            })
        ]
    });
    if (href && !disabled && !loading) {
        var onClick = props.onClick, anchorProps = (0,_object_without_properties/* default */.Z)(props, [
            "onClick"
        ]);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: ref,
                className: buttonClasses,
                style: buttonStyle,
                onClick: onClick
            }, anchorProps), {
                children: content
            }))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        className: buttonClasses,
        disabled: disabled || loading,
        style: buttonStyle
    }, props), {
        children: content
    }));
});
Button.displayName = "Button";
/* harmony default export */ var Button_Button = (Button);

;// CONCATENATED MODULE: ./components/Button/index.ts



/***/ }),

/***/ 39181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZT": function() { return /* reexport */ Typography; },
  "ZP": function() { return /* reexport */ Typography; }
});

// UNUSED EXPORTS: Body, BodyLarge, BodySmall, Caption, Code, Heading1, Heading2, Heading3, Heading4, Heading5, Heading6, Label

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(57389);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(77637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(59072);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./hooks/useTheme.ts
var useTheme = __webpack_require__(14866);
// EXTERNAL MODULE: ./components/Typography/Typography.module.scss
var Typography_module = __webpack_require__(30615);
var Typography_module_default = /*#__PURE__*/__webpack_require__.n(Typography_module);
;// CONCATENATED MODULE: ./components/Typography/Typography.tsx








// Helper function to get responsive class names
var getResponsiveClasses = function(prop, prefix) {
    if (!prop) return "";
    if (typeof prop === "string") {
        return "".concat(prefix, "-").concat(prop);
    }
    var classes = [];
    Object.entries(prop).forEach(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), breakpoint = _param[0], value = _param[1];
        if (value) {
            classes.push("".concat(prefix, "-").concat(breakpoint, "-").concat(value));
        }
    });
    return classes.join(" ");
};
// Helper function to get color value from theme
var getColorValue = function(color, theme) {
    switch(color){
        case "primary":
            return theme.colors.text.primary;
        case "secondary":
            return theme.colors.text.secondary;
        case "disabled":
            return theme.colors.text.disabled;
        case "error":
            return theme.colors.error;
        case "warning":
            return theme.colors.warning;
        case "success":
            return theme.colors.success;
        case "info":
            return theme.colors.info;
        case "inherit":
            return "inherit";
        case "brand":
            return theme.colors.palettes.brand[500];
        case "brand-25":
            return theme.colors.palettes.brand[25];
        case "brand-50":
            return theme.colors.palettes.brand[50];
        case "brand-100":
            return theme.colors.palettes.brand[100];
        case "brand-200":
            return theme.colors.palettes.brand[200];
        case "brand-300":
            return theme.colors.palettes.brand[300];
        case "brand-400":
            return theme.colors.palettes.brand[400];
        case "brand-500":
            return theme.colors.palettes.brand[500];
        case "brand-600":
            return theme.colors.palettes.brand[600];
        case "brand-700":
            return theme.colors.palettes.brand[700];
        case "brand-800":
            return theme.colors.palettes.brand[800];
        case "brand-900":
            return theme.colors.palettes.brand[900];
        case "brand-950":
            return theme.colors.palettes.brand[950];
        case "tertiary-25":
            return theme.colors.palettes.tertiary[25];
        case "tertiary-50":
            return theme.colors.palettes.tertiary[50];
        case "tertiary-100":
            return theme.colors.palettes.tertiary[100];
        case "tertiary-200":
            return theme.colors.palettes.tertiary[200];
        case "tertiary-300":
            return theme.colors.palettes.tertiary[300];
        case "tertiary-400":
            return theme.colors.palettes.tertiary[400];
        case "tertiary-500":
            return theme.colors.palettes.tertiary[500];
        case "tertiary-600":
            return theme.colors.palettes.tertiary[600];
        case "tertiary-700":
            return theme.colors.palettes.tertiary[700];
        case "tertiary-800":
            return theme.colors.palettes.tertiary[800];
        case "tertiary-900":
            return theme.colors.palettes.tertiary[900];
        case "tertiary-950":
            return theme.colors.palettes.tertiary[950];
        case "grayDark-25":
            return theme.colors.palettes.grayDark[25];
        case "grayDark-50":
            return theme.colors.palettes.grayDark[50];
        case "grayDark-100":
            return theme.colors.palettes.grayDark[100];
        case "grayDark-200":
            return theme.colors.palettes.grayDark[200];
        case "grayDark-300":
            return theme.colors.palettes.grayDark[300];
        case "grayDark-400":
            return theme.colors.palettes.grayDark[400];
        case "grayDark-500":
            return theme.colors.palettes.grayDark[500];
        case "grayDark-600":
            return theme.colors.palettes.grayDark[600];
        case "grayDark-700":
            return theme.colors.palettes.grayDark[700];
        case "grayDark-800":
            return theme.colors.palettes.grayDark[800];
        case "grayDark-900":
            return theme.colors.palettes.grayDark[900];
        case "grayDark-950":
            return theme.colors.palettes.grayDark[950];
        case "light-primary":
            return theme.mode === "light" ? theme.colors.text.primary : theme.colors.palettes.grayLight[900];
        case "light-secondary":
            return theme.mode === "light" ? theme.colors.text.secondary : theme.colors.palettes.grayLight[600];
        case "light-disabled":
            return theme.mode === "light" ? theme.colors.text.disabled : theme.colors.palettes.grayLight[400];
        default:
            return theme.colors.text.primary;
    }
};
// Helper function to check if fontSize/lineHeight is responsive
var isResponsive = function(value) {
    return value && typeof value === "object" && ("sm" in value || "md" in value || "lg" in value);
};
// Helper function to get responsive CSS custom properties
var getResponsiveCSS = function(responsiveValue, property) {
    if (!isResponsive(responsiveValue)) return "";
    var cssVars = [];
    if (responsiveValue.sm) {
        cssVars.push("--".concat(property, "-sm: ").concat(responsiveValue.sm.rem, ";"));
    }
    if (responsiveValue.md) {
        cssVars.push("--".concat(property, "-md: ").concat(responsiveValue.md.rem, ";"));
    }
    if (responsiveValue.lg) {
        cssVars.push("--".concat(property, "-lg: ").concat(responsiveValue.lg.rem, ";"));
    }
    return cssVars.join(" ");
};
// Helper function to get typography styles from theme
var getTypographyStyles = function(variant, theme) {
    var typography = theme.typography;
    // Handle display variants
    if (variant.startsWith("display-")) {
        var displayVariant = variant.replace("display-", "");
        if (displayVariant in typography.display) {
            var styles = typography.display[displayVariant];
            // Check if responsive
            if (isResponsive(styles.fontSize)) {
                var ref, ref1, ref2, ref3;
                var _obj;
                return _obj = {
                    fontSize: "var(--font-size-md)",
                    lineHeight: isResponsive(styles.lineHeight) ? "var(--line-height-md)" : styles.lineHeight.rem,
                    letterSpacing: styles.letterSpacing,
                    fontWeight: typography.fontWeight[styles.fontWeight]
                }, // Add CSS custom properties for responsive values
                (0,_define_property/* default */.Z)(_obj, "--font-size-sm", (ref = styles.fontSize.sm) === null || ref === void 0 ? void 0 : ref.rem), (0,_define_property/* default */.Z)(_obj, "--font-size-md", (ref1 = styles.fontSize.md) === null || ref1 === void 0 ? void 0 : ref1.rem), (0,_define_property/* default */.Z)(_obj, "--line-height-sm", (ref2 = styles.lineHeight.sm) === null || ref2 === void 0 ? void 0 : ref2.rem), (0,_define_property/* default */.Z)(_obj, "--line-height-md", (ref3 = styles.lineHeight.md) === null || ref3 === void 0 ? void 0 : ref3.rem), _obj;
            }
            return {
                fontSize: styles.fontSize.rem,
                lineHeight: styles.lineHeight.rem,
                letterSpacing: styles.letterSpacing,
                fontWeight: typography.fontWeight[styles.fontWeight]
            };
        }
    }
    // Handle text variants
    if (variant.startsWith("text-")) {
        var textVariant = variant.replace("text-", "");
        if (textVariant in typography.text) {
            var styles1 = typography.text[textVariant];
            // Check if responsive
            if (isResponsive(styles1.fontSize)) {
                var ref4, ref5, ref6, ref7;
                var _obj1;
                return _obj1 = {
                    fontSize: "var(--font-size-md)",
                    lineHeight: isResponsive(styles1.lineHeight) ? "var(--line-height-md)" : styles1.lineHeight.rem,
                    fontWeight: typography.fontWeight[styles1.fontWeight]
                }, // Add CSS custom properties for responsive values
                (0,_define_property/* default */.Z)(_obj1, "--font-size-sm", (ref4 = styles1.fontSize.sm) === null || ref4 === void 0 ? void 0 : ref4.rem), (0,_define_property/* default */.Z)(_obj1, "--font-size-md", (ref5 = styles1.fontSize.md) === null || ref5 === void 0 ? void 0 : ref5.rem), (0,_define_property/* default */.Z)(_obj1, "--line-height-sm", (ref6 = styles1.lineHeight.sm) === null || ref6 === void 0 ? void 0 : ref6.rem), (0,_define_property/* default */.Z)(_obj1, "--line-height-md", (ref7 = styles1.lineHeight.md) === null || ref7 === void 0 ? void 0 : ref7.rem), _obj1;
            }
            return {
                fontSize: styles1.fontSize.rem,
                lineHeight: styles1.lineHeight.rem,
                fontWeight: typography.fontWeight[styles1.fontWeight]
            };
        }
    }
    // Handle direct variants (backward compatibility)
    if (variant in typography.display) {
        var displayVariant1 = variant;
        var styles2 = typography.display[displayVariant1];
        if (isResponsive(styles2.fontSize)) {
            var ref8, ref9, ref10, ref11;
            var _obj2;
            return _obj2 = {
                fontSize: "var(--font-size-md)",
                lineHeight: isResponsive(styles2.lineHeight) ? "var(--line-height-md)" : styles2.lineHeight.rem,
                letterSpacing: styles2.letterSpacing,
                fontWeight: typography.fontWeight[styles2.fontWeight]
            }, (0,_define_property/* default */.Z)(_obj2, "--font-size-sm", (ref8 = styles2.fontSize.sm) === null || ref8 === void 0 ? void 0 : ref8.rem), (0,_define_property/* default */.Z)(_obj2, "--font-size-md", (ref9 = styles2.fontSize.md) === null || ref9 === void 0 ? void 0 : ref9.rem), (0,_define_property/* default */.Z)(_obj2, "--line-height-sm", (ref10 = styles2.lineHeight.sm) === null || ref10 === void 0 ? void 0 : ref10.rem), (0,_define_property/* default */.Z)(_obj2, "--line-height-md", (ref11 = styles2.lineHeight.md) === null || ref11 === void 0 ? void 0 : ref11.rem), _obj2;
        }
        return {
            fontSize: styles2.fontSize.rem,
            lineHeight: styles2.lineHeight.rem,
            letterSpacing: styles2.letterSpacing,
            fontWeight: typography.fontWeight[styles2.fontWeight]
        };
    }
    if (variant in typography.text) {
        var textVariant1 = variant;
        var styles3 = typography.text[textVariant1];
        // Special handling for text-md responsive variant
        if (textVariant1 === "md" && isResponsive(styles3.fontSize)) {
            var ref12, ref13, ref14, ref15;
            var responsiveFontSize = styles3.fontSize;
            var responsiveLineHeight = styles3.lineHeight;
            var _obj3;
            return _obj3 = {
                fontSize: "var(--font-size-md)",
                lineHeight: "var(--line-height-md)",
                fontWeight: typography.fontWeight[styles3.fontWeight]
            }, (0,_define_property/* default */.Z)(_obj3, "--font-size-sm", (ref12 = responsiveFontSize.sm) === null || ref12 === void 0 ? void 0 : ref12.rem), (0,_define_property/* default */.Z)(_obj3, "--font-size-md", (ref13 = responsiveFontSize.md) === null || ref13 === void 0 ? void 0 : ref13.rem), (0,_define_property/* default */.Z)(_obj3, "--line-height-sm", (ref14 = responsiveLineHeight.sm) === null || ref14 === void 0 ? void 0 : ref14.rem), (0,_define_property/* default */.Z)(_obj3, "--line-height-md", (ref15 = responsiveLineHeight.md) === null || ref15 === void 0 ? void 0 : ref15.rem), _obj3;
        }
        if (isResponsive(styles3.fontSize)) {
            var ref16, ref17, ref18, ref19;
            var _obj4;
            return _obj4 = {
                fontSize: "var(--font-size-md)",
                lineHeight: isResponsive(styles3.lineHeight) ? "var(--line-height-md)" : styles3.lineHeight.rem,
                fontWeight: typography.fontWeight[styles3.fontWeight]
            }, (0,_define_property/* default */.Z)(_obj4, "--font-size-sm", (ref16 = styles3.fontSize.sm) === null || ref16 === void 0 ? void 0 : ref16.rem), (0,_define_property/* default */.Z)(_obj4, "--font-size-md", (ref17 = styles3.fontSize.md) === null || ref17 === void 0 ? void 0 : ref17.rem), (0,_define_property/* default */.Z)(_obj4, "--line-height-sm", (ref18 = styles3.lineHeight.sm) === null || ref18 === void 0 ? void 0 : ref18.rem), (0,_define_property/* default */.Z)(_obj4, "--line-height-md", (ref19 = styles3.lineHeight.md) === null || ref19 === void 0 ? void 0 : ref19.rem), _obj4;
        }
        return {
            fontSize: styles3.fontSize.rem,
            lineHeight: styles3.lineHeight.rem,
            fontWeight: typography.fontWeight[styles3.fontWeight]
        };
    }
    return {};
};
// Main Typography component
var Typography = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var children = _param.children, _variant = _param.variant, variant = _variant === void 0 ? "md" : _variant, as = _param.as, _color = _param.color, color = _color === void 0 ? "primary" : _color, weight = _param.weight, family = _param.family, align = _param.align, transform = _param.transform, decoration = _param.decoration, className = _param.className, style = _param.style, _truncate = _param.truncate, truncate = _truncate === void 0 ? false : _truncate, _noWrap = _param.noWrap, noWrap = _noWrap === void 0 ? false : _noWrap, _selectable = _param.selectable, selectable = _selectable === void 0 ? true : _selectable, margin = _param.margin, padding = _param.padding, customColor = _param.customColor, lineHeight = _param.lineHeight, letterSpacing = _param.letterSpacing, fontSize = _param.fontSize, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "variant",
        "as",
        "color",
        "weight",
        "family",
        "align",
        "transform",
        "decoration",
        "className",
        "style",
        "truncate",
        "noWrap",
        "selectable",
        "margin",
        "padding",
        "customColor",
        "lineHeight",
        "letterSpacing",
        "fontSize"
    ]);
    var theme = (0,useTheme/* useThemeStyles */.Gr)();
    // Determine the HTML element to render
    var getElement = function() {
        if (as) return as;
        // Auto-determine element based on variant
        if (variant.startsWith("display")) {
            var size = variant.replace("display", "");
            switch(size){
                case "2xl":
                case "xl":
                    return "h1";
                case "lg":
                case "md":
                    return "h2";
                case "sm":
                case "xs":
                    return "h3";
                default:
                    return "h1";
            }
        }
        return "p";
    };
    var Element = getElement();
    // Build class names
    var classes = [
        (Typography_module_default()).typography,
        (Typography_module_default())["variant-".concat(variant)],
        getResponsiveClasses(color, "color"),
        getResponsiveClasses(weight, "weight"),
        getResponsiveClasses(family, "family"),
        getResponsiveClasses(align, "align"),
        getResponsiveClasses(transform, "transform"),
        getResponsiveClasses(decoration, "decoration"),
        truncate && (Typography_module_default()).truncate,
        noWrap && (Typography_module_default()).noWrap,
        !selectable && (Typography_module_default()).noSelect,
        className, 
    ].filter(Boolean).join(" ");
    // Build inline styles
    var inlineStyles = (0,_object_spread/* default */.Z)({}, getTypographyStyles(variant, theme), style);
    // Add color
    if (customColor) {
        inlineStyles.color = customColor;
    } else if (typeof color === "string") {
        inlineStyles.color = getColorValue(color, theme);
    }
    // Add font family
    if (family && typeof family === "string") {
        inlineStyles.fontFamily = theme.typography.fontFamily[family];
    }
    // Add font weight
    if (weight && typeof weight === "string") {
        inlineStyles.fontWeight = theme.typography.fontWeight[weight];
    }
    // Add text alignment
    if (align && typeof align === "string") {
        inlineStyles.textAlign = align;
    }
    // Add text transform
    if (transform && typeof transform === "string") {
        inlineStyles.textTransform = transform;
    }
    // Add text decoration
    if (decoration && typeof decoration === "string") {
        inlineStyles.textDecoration = decoration;
    }
    // Add spacing
    if (margin && typeof margin === "string") {
        inlineStyles.margin = margin;
    }
    if (padding && typeof padding === "string") {
        inlineStyles.padding = padding;
    }
    // Add overrides - these should have higher priority
    if (lineHeight && typeof lineHeight === "string") {
        inlineStyles["--custom-line-height"] = lineHeight;
    }
    if (letterSpacing && typeof letterSpacing === "string") {
        inlineStyles["--custom-letter-spacing"] = letterSpacing;
    }
    if (fontSize && typeof fontSize === "string") {
        inlineStyles["--custom-font-size"] = fontSize;
    }
    return /*#__PURE__*/ react.createElement(Element, (0,_object_spread/* default */.Z)({
        ref: ref,
        className: classes,
        style: inlineStyles
    }, props), children);
});
Typography.displayName = "Typography";
// Convenience components for common use cases
var Heading1 = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, (0,_object_spread/* default */.Z)({
        ref: ref,
        variant: "display-2xl",
        as: "h1"
    }, props));
});
var Heading2 = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, (0,_object_spread/* default */.Z)({
        ref: ref,
        variant: "display-xl",
        as: "h2"
    }, props));
});
var Heading3 = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, (0,_object_spread/* default */.Z)({
        ref: ref,
        variant: "display-lg",
        as: "h3"
    }, props));
});
var Heading4 = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, (0,_object_spread/* default */.Z)({
        ref: ref,
        variant: "display-md",
        as: "h4"
    }, props));
});
var Heading5 = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, (0,_object_spread/* default */.Z)({
        ref: ref,
        variant: "display-sm",
        as: "h5"
    }, props));
});
var Heading6 = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, (0,_object_spread/* default */.Z)({
        ref: ref,
        variant: "display-xs",
        as: "h6"
    }, props));
});
var BodyLarge = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, (0,_object_spread/* default */.Z)({
        ref: ref,
        variant: "text-xl",
        as: "p"
    }, props));
});
var Body = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, (0,_object_spread/* default */.Z)({
        ref: ref,
        variant: "text-md",
        as: "p"
    }, props));
});
var BodySmall = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, (0,_object_spread/* default */.Z)({
        ref: ref,
        variant: "text-sm",
        as: "p"
    }, props));
});
var Caption = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, (0,_object_spread/* default */.Z)({
        ref: ref,
        variant: "text-xs",
        as: "span"
    }, props));
});
var Label = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, (0,_object_spread/* default */.Z)({
        ref: ref,
        variant: "text-sm",
        as: "label",
        weight: "medium"
    }, props));
});
var Code = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, (0,_object_spread/* default */.Z)({
        ref: ref,
        variant: "text-sm",
        as: "code",
        family: "secondary",
        style: {
            backgroundColor: "rgba(0,0,0,0.1)",
            padding: "0.125rem 0.25rem",
            borderRadius: "0.25rem"
        }
    }, props));
});
Heading1.displayName = "Heading1";
Heading2.displayName = "Heading2";
Heading3.displayName = "Heading3";
Heading4.displayName = "Heading4";
Heading5.displayName = "Heading5";
Heading6.displayName = "Heading6";
BodyLarge.displayName = "BodyLarge";
Body.displayName = "Body";
BodySmall.displayName = "BodySmall";
Caption.displayName = "Caption";
Label.displayName = "Label";
Code.displayName = "Code";

;// CONCATENATED MODULE: ./components/Typography/index.ts
// Main Typography component and types

// Convenience components

// Examples
// Default export



/***/ }),

/***/ 14866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fg": function() { return /* binding */ useTheme; },
/* harmony export */   "Gr": function() { return /* binding */ useThemeStyles; }
/* harmony export */ });
/* unused harmony export useThemeMode */
/* harmony import */ var _contexts_ThemeContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40365);

/**
 * Custom hook to access theme context
 * This hook provides access to the current theme, mode, and setMode function
 *
 * @returns {ThemeContextType} Theme context with theme object, mode, and setMode function
 *
 * @example
 * ```tsx
 * import { useTheme } from '../hooks/useTheme';
 *
 * function MyComponent() {
 *   const { theme, mode, setMode } = useTheme();
 *
 *   return (
 *     <div style={{
 *       backgroundColor: theme.colors.background,
 *       color: theme.colors.text.primary
 *     }}>
 *       Current mode: {mode}
 *     </div>
 *   );
 * }
 * ```
 */ var useTheme = function() {
    return (0,_contexts_ThemeContext__WEBPACK_IMPORTED_MODULE_0__/* .useTheme */ .F)();
};
/**
 * Hook to get only the theme object
 * Useful when you only need the theme styles without mode management
 *
 * @returns {Theme} Current theme object
 *
 * @example
 * ```tsx
 * import { useThemeStyles } from '../hooks/useTheme';
 *
 * function MyComponent() {
 *   const theme = useThemeStyles();
 *
 *   return (
 *     <div style={{
 *       backgroundColor: theme.colors.background,
 *       color: theme.colors.text.primary
 *     }}>
 *       Content
 *     </div>
 *   );
 * }
 * ```
 */ var useThemeStyles = function() {
    var theme = (0,_contexts_ThemeContext__WEBPACK_IMPORTED_MODULE_0__/* .useTheme */ .F)().theme;
    return theme;
};
/**
 * Hook to get only the current theme mode
 * Useful when you only need to check the current mode
 *
 * @returns {ThemeMode} Current theme mode ('light' or 'dark')
 *
 * @example
 * ```tsx
 * import { useThemeMode } from '../hooks/useTheme';
 *
 * function MyComponent() {
 *   const mode = useThemeMode();
 *
 *   return (
 *     <div>
 *       Current theme: {mode}
 *     </div>
 *   );
 * }
 * ```
 */ var useThemeMode = function() {
    var mode = useThemeContext().mode;
    return mode;
};


/***/ }),

/***/ 27148:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__30ukX","loading":"Button_loading__neFI3","sm":"Button_sm__dXshS","md":"Button_md__GOfSN","lg":"Button_lg__BeuBH","secondary":"Button_secondary__X4hrj","text":"Button_text__d9Ltb","outline":"Button_outline__bjSBY","warning":"Button_warning__40e3d","fullWidth":"Button_fullWidth__L87a1","autoWidth":"Button_autoWidth__iFeaB","content":"Button_content__P_obf","iconLeft":"Button_iconLeft__jnyk6","iconRight":"Button_iconRight__kc6GM","spinner":"Button_spinner__s2_At","spinnerInner":"Button_spinnerInner__GViOx","spin":"Button_spin__1Mwss","primary":"Button_primary__RWocB"};

/***/ }),

/***/ 30615:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"typography":"Typography_typography__OdkZX","truncate":"Typography_truncate__crECq","noWrap":"Typography_noWrap__v6YfW","noSelect":"Typography_noSelect__RPRPa","color-primary":"Typography_color-primary__ohqsH","color-secondary":"Typography_color-secondary__VsJGh","color-disabled":"Typography_color-disabled__BGw9u","color-error":"Typography_color-error__wakc8","color-warning":"Typography_color-warning__WEzAQ","color-success":"Typography_color-success___SC_y","color-info":"Typography_color-info__9pr7E","color-inherit":"Typography_color-inherit__h3Q9S","weight-light":"Typography_weight-light__7a7X_","weight-normal":"Typography_weight-normal___OoTR","weight-regular":"Typography_weight-regular__XMXLK","weight-medium":"Typography_weight-medium__L4BNr","weight-semibold":"Typography_weight-semibold__VwhFP","weight-bold":"Typography_weight-bold__7u3Fx","family-primary":"Typography_family-primary__uJ7fk","family-secondary":"Typography_family-secondary__XadYa","align-left":"Typography_align-left__J2bLd","align-center":"Typography_align-center__60OIh","align-right":"Typography_align-right__3MsvF","align-justify":"Typography_align-justify__jytQA","transform-none":"Typography_transform-none__0kTu8","transform-uppercase":"Typography_transform-uppercase__iEKGe","transform-lowercase":"Typography_transform-lowercase__31FI_","transform-capitalize":"Typography_transform-capitalize__WD6sr","decoration-none":"Typography_decoration-none__p7Sx4","decoration-underline":"Typography_decoration-underline__XLPI5","decoration-line-through":"Typography_decoration-line-through__LBFZw","decoration-overline":"Typography_decoration-overline__CYo99","color-sm-primary":"Typography_color-sm-primary__uLJbJ","color-sm-secondary":"Typography_color-sm-secondary__Ri5xP","color-sm-disabled":"Typography_color-sm-disabled__beisW","color-sm-error":"Typography_color-sm-error__zxQcW","color-sm-warning":"Typography_color-sm-warning__mAcwH","color-sm-success":"Typography_color-sm-success__d605b","color-sm-info":"Typography_color-sm-info__25vva","color-sm-inherit":"Typography_color-sm-inherit__pGvLJ","color-md-primary":"Typography_color-md-primary__qSnqo","color-md-secondary":"Typography_color-md-secondary__ce_4_","color-md-disabled":"Typography_color-md-disabled__Zd3SM","color-md-error":"Typography_color-md-error__2_Yvz","color-md-warning":"Typography_color-md-warning__I074o","color-md-success":"Typography_color-md-success__PE1hW","color-md-info":"Typography_color-md-info__XCeTh","color-md-inherit":"Typography_color-md-inherit__cRJ1I","color-lg-primary":"Typography_color-lg-primary__PtJaO","color-lg-secondary":"Typography_color-lg-secondary__3QDMF","color-lg-disabled":"Typography_color-lg-disabled__BmeyH","color-lg-error":"Typography_color-lg-error__z1iye","color-lg-warning":"Typography_color-lg-warning__GR1Po","color-lg-success":"Typography_color-lg-success__PNGL1","color-lg-info":"Typography_color-lg-info__jN_yK","color-lg-inherit":"Typography_color-lg-inherit__nEMwn","color-xl-primary":"Typography_color-xl-primary__PgUGZ","color-xl-secondary":"Typography_color-xl-secondary__6EJNn","color-xl-disabled":"Typography_color-xl-disabled__VXAAt","color-xl-error":"Typography_color-xl-error__GuzQs","color-xl-warning":"Typography_color-xl-warning__5eAnb","color-xl-success":"Typography_color-xl-success__mMAw7","color-xl-info":"Typography_color-xl-info__Rg5kL","color-xl-inherit":"Typography_color-xl-inherit__l3JRJ","color-2xl-primary":"Typography_color-2xl-primary__ZCZOw","color-2xl-secondary":"Typography_color-2xl-secondary__o_s8U","color-2xl-disabled":"Typography_color-2xl-disabled__eq_k4","color-2xl-error":"Typography_color-2xl-error__Vc0wI","color-2xl-warning":"Typography_color-2xl-warning__aR15C","color-2xl-success":"Typography_color-2xl-success__toqxS","color-2xl-info":"Typography_color-2xl-info__jSVNh","color-2xl-inherit":"Typography_color-2xl-inherit__kVC3Q","weight-sm-light":"Typography_weight-sm-light__1thk1","weight-sm-normal":"Typography_weight-sm-normal__rdcKB","weight-sm-regular":"Typography_weight-sm-regular__KGMeU","weight-sm-medium":"Typography_weight-sm-medium__p13Ie","weight-sm-semibold":"Typography_weight-sm-semibold__oq1SS","weight-sm-bold":"Typography_weight-sm-bold__J4z4n","weight-md-light":"Typography_weight-md-light__0897q","weight-md-normal":"Typography_weight-md-normal__JLudK","weight-md-regular":"Typography_weight-md-regular__AmpWN","weight-md-medium":"Typography_weight-md-medium__L2Oc_","weight-md-semibold":"Typography_weight-md-semibold__f_Nyj","weight-md-bold":"Typography_weight-md-bold__GcHfD","weight-lg-light":"Typography_weight-lg-light__AkTBk","weight-lg-normal":"Typography_weight-lg-normal__6mOas","weight-lg-regular":"Typography_weight-lg-regular__vWtlx","weight-lg-medium":"Typography_weight-lg-medium__rUKfQ","weight-lg-semibold":"Typography_weight-lg-semibold__q6Ffj","weight-lg-bold":"Typography_weight-lg-bold__bIntv","weight-xl-light":"Typography_weight-xl-light__i0zlb","weight-xl-normal":"Typography_weight-xl-normal____Tau","weight-xl-regular":"Typography_weight-xl-regular__5yzeQ","weight-xl-medium":"Typography_weight-xl-medium__mYaTK","weight-xl-semibold":"Typography_weight-xl-semibold___HVbE","weight-xl-bold":"Typography_weight-xl-bold__ir7vU","weight-2xl-light":"Typography_weight-2xl-light__320rN","weight-2xl-normal":"Typography_weight-2xl-normal__e8_Go","weight-2xl-regular":"Typography_weight-2xl-regular__S3_Di","weight-2xl-medium":"Typography_weight-2xl-medium__jvHRO","weight-2xl-semibold":"Typography_weight-2xl-semibold__Nywcb","weight-2xl-bold":"Typography_weight-2xl-bold__fklDG","family-sm-primary":"Typography_family-sm-primary__po1ou","family-sm-secondary":"Typography_family-sm-secondary__OT4a8","family-md-primary":"Typography_family-md-primary__ulFFu","family-md-secondary":"Typography_family-md-secondary__qlJOS","family-lg-primary":"Typography_family-lg-primary__9Izf0","family-lg-secondary":"Typography_family-lg-secondary__8ISGl","family-xl-primary":"Typography_family-xl-primary__6Uiy0","family-xl-secondary":"Typography_family-xl-secondary__kb661","family-2xl-primary":"Typography_family-2xl-primary__WWkgS","family-2xl-secondary":"Typography_family-2xl-secondary__T6X2F","align-sm-left":"Typography_align-sm-left__WluFX","align-sm-center":"Typography_align-sm-center__kIYoA","align-sm-right":"Typography_align-sm-right__oFc27","align-sm-justify":"Typography_align-sm-justify__tY0Oo","align-md-left":"Typography_align-md-left__KKP_a","align-md-center":"Typography_align-md-center__9aUwH","align-md-right":"Typography_align-md-right__mb_d2","align-md-justify":"Typography_align-md-justify__pRC3Q","align-lg-left":"Typography_align-lg-left__DRA3k","align-lg-center":"Typography_align-lg-center__TGqTZ","align-lg-right":"Typography_align-lg-right__4kQzE","align-lg-justify":"Typography_align-lg-justify__So68R","align-xl-left":"Typography_align-xl-left__nVOnx","align-xl-center":"Typography_align-xl-center__atSav","align-xl-right":"Typography_align-xl-right__7SXS_","align-xl-justify":"Typography_align-xl-justify__Uz_rT","align-2xl-left":"Typography_align-2xl-left__LmMcQ","align-2xl-center":"Typography_align-2xl-center__uZmdL","align-2xl-right":"Typography_align-2xl-right__yIFjO","align-2xl-justify":"Typography_align-2xl-justify__2mspj","transform-sm-none":"Typography_transform-sm-none__XdsxK","transform-sm-uppercase":"Typography_transform-sm-uppercase__IthoK","transform-sm-lowercase":"Typography_transform-sm-lowercase__qF6s7","transform-sm-capitalize":"Typography_transform-sm-capitalize__ipMSy","transform-md-none":"Typography_transform-md-none__mGz47","transform-md-uppercase":"Typography_transform-md-uppercase__AelPW","transform-md-lowercase":"Typography_transform-md-lowercase__O86hK","transform-md-capitalize":"Typography_transform-md-capitalize__XhLVN","transform-lg-none":"Typography_transform-lg-none__7p3PF","transform-lg-uppercase":"Typography_transform-lg-uppercase__rpMo1","transform-lg-lowercase":"Typography_transform-lg-lowercase__d__zG","transform-lg-capitalize":"Typography_transform-lg-capitalize__q6rMN","transform-xl-none":"Typography_transform-xl-none__LONqx","transform-xl-uppercase":"Typography_transform-xl-uppercase__5U8Ov","transform-xl-lowercase":"Typography_transform-xl-lowercase__ZKc67","transform-xl-capitalize":"Typography_transform-xl-capitalize__6xCqQ","transform-2xl-none":"Typography_transform-2xl-none__1ucxe","transform-2xl-uppercase":"Typography_transform-2xl-uppercase__nP7YC","transform-2xl-lowercase":"Typography_transform-2xl-lowercase__wYSVA","transform-2xl-capitalize":"Typography_transform-2xl-capitalize__AsKhl","decoration-sm-none":"Typography_decoration-sm-none__9QDRa","decoration-sm-underline":"Typography_decoration-sm-underline__WnaxQ","decoration-sm-line-through":"Typography_decoration-sm-line-through__aUvuT","decoration-sm-overline":"Typography_decoration-sm-overline__29VJM","decoration-md-none":"Typography_decoration-md-none___ScT_","decoration-md-underline":"Typography_decoration-md-underline__Cipvw","decoration-md-line-through":"Typography_decoration-md-line-through__d1qJ_","decoration-md-overline":"Typography_decoration-md-overline__FNIDc","decoration-lg-none":"Typography_decoration-lg-none__vlo_Y","decoration-lg-underline":"Typography_decoration-lg-underline__eFnEj","decoration-lg-line-through":"Typography_decoration-lg-line-through__s7MWf","decoration-lg-overline":"Typography_decoration-lg-overline__MhbTy","decoration-xl-none":"Typography_decoration-xl-none__6H_8z","decoration-xl-underline":"Typography_decoration-xl-underline__lg_of","decoration-xl-line-through":"Typography_decoration-xl-line-through__ArR_L","decoration-xl-overline":"Typography_decoration-xl-overline__V2H5n","decoration-2xl-none":"Typography_decoration-2xl-none__jYZIc","decoration-2xl-underline":"Typography_decoration-2xl-underline__NycT0","decoration-2xl-line-through":"Typography_decoration-2xl-line-through__ZAfq_","decoration-2xl-overline":"Typography_decoration-2xl-overline__Uw3J0","variant-text-md":"Typography_variant-text-md__GAokv","variant-text-sm":"Typography_variant-text-sm__cGzc9","variant-display-md":"Typography_variant-display-md__ppBpx","variant-display-lg":"Typography_variant-display-lg__snYaB","variant-display-sm":"Typography_variant-display-sm__Gpbxd","variant-display-xl":"Typography_variant-display-xl__wWE0G","variant-display-xs":"Typography_variant-display-xs__R747r","variant-text-lg":"Typography_variant-text-lg__DjKUs","variant-text-xl":"Typography_variant-text-xl__8NHiU"};

/***/ })

}]);